// extracted by css-extract-rspack-plugin
export default {"fieldItem":"o2UGYE851lUmbIR9","fieldLabel":"xBGrTrtJ0ckiOHE_","requiredMark":"DZ6KLy4VabYTSUe_"};